/* eslint-disable semi */
<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 400px; top: 40%;left: 40%;transform: translate(-50%, -50%);}
.title{width: 660px; height: 30px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 30px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-content {width: 690px;height: 370px;;color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;}
.ol-popup-closer:after {content: "✖";}
//设置整个table样式
/deep/.el-table{background: none !important;}
//修改表格头部样式
/deep/.el-table tr {background: none !important; }
/deep/.el-table tr .is-center{background: none !important; color: #fff; border: none;}
//修改分页菜单yangs
/deep/.el-pager li{background: transparent !important; color: #fff;}
/deep/.el-pager > .active{background: transparent !important; color: #23fffc;}
/deep/.btn-prev{background: transparent !important;color: #fff !important;}
/deep/.btn-next{background: transparent !important;color: #fff !important;}
/deep/.el-table__header th {padding: 0;height: 30px;}
/deep/.el-table__body td {padding: 0;height: 30px;}
.echarts {height: 40px;line-height: 40px;}
.echarts span{display: inline-block;height: 30px;line-height: 30px;;border: 1px solid rgba(33, 185, 191, 0.6);padding: 0px 5px;}
.echarts span:hover {cursor: pointer;}
.positioning {cursor: pointer;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>空间分析</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <div class="echarts">
        <span @click="drawbar('bar')"><i class="iconfont icon-zhuzhuangtu"></i>柱状图</span>
        <span @click="drawbar('pie')"><i class="iconfont icon-bingzhuangtu"></i>饼图</span>
        <span @click="drawbar('line')"><i class="iconfont icon-tubiao-zhexiantu"></i>折线图</span>
        <span @click="onClickExpExcel()"><i class="iconfont icon-daochu"></i>导出报表</span>
      </div>
      <el-table :header-cell-style="headercell" :row-style='rowstyles' :data="tableData" stripe height="320" style="width: 100%">
        <el-table-column align="center" prop="owner" label="国家"></el-table-column>
        <el-table-column align="center" prop="scale" label="规模"></el-table-column>
        <el-table-column align="center" prop="type" label="类型"></el-table-column>
        <el-table-column align="center" prop="type" label="位置">
          <template slot-scope="scope">
            <span @click="positioning(scope.row)" class="positioning">定位</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Draw from 'ol/interaction/Draw'
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style'
import WFS from 'ol/format/WFS'
import {bbox} from 'ol/format/filter'
import Axios from 'axios'
import SpaceQuery from './SpaceQuery'
let draw
export default {
  name: '',
  mixins: [SpaceQuery],
  data()
  {
    return {
      measureAry: [],
      flag: false,
      tableData: [],
      temp: [],
      xAxisdata: [],
      seriesdata: [],
      LayernarData: [],
      Layernar: []
    }
  },
  computed: {
    TableData()
    {
      return this.tableData
    }
  },
  methods:
  {
    /**
     * 创建图形
     * @method
     * @param {String} type 绘制类型 例如 点、线、多边形
     * @param {Array} Layernar 空间分析的图层名称
     */
    drawGraphical(type, Layernar)
    {
      window.map.removeInteraction(draw)
      let self = this
      let feature
      let Polygon = this.drawPolygon()
      this.measureAry.push(Polygon)
      draw = new Draw({
        source: Polygon.getSource(),
        type: type
      })
      window.map.addInteraction(draw)
      draw.on('drawend', function(evt)
      {
        feature = evt.feature
        self.loadWfsGetFeatures(feature, Layernar)
      })
    },
    //绘制多边形
    drawPolygon()
    {
      const vector = new VectorLayer({
        source: new VectorSource(),
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      })
      this.LayernarData.push(vector)
      window.map.addLayer(vector)
      return vector
    },
    //属性分析
    async loadWfsGetFeatures(feature, Layernar)
    {
      if (Layernar.length === 0)
        return this.$message({message: '请先勾选图层', type: 'warning', customClass: 'mzindex'})
      this.$parent.loading = true
      let featureRequest = new WFS().writeGetFeature({
        srsName: 'EPSG:4326',
        featureNS: 'http://www.camining.cn/geoserver/gisdny/',
        featureTypes: Layernar,
        outputFormat: 'application/json',
        filter: bbox('the_geom', feature.getGeometry().getExtent(), 'EPSG:4326')
      })
      let conf =
      {
        headers: {'Content-Type': 'application/json'}
      }
      let ret = await Axios.post('http://www.camining.cn/geoserver/gisdny/wfs', new XMLSerializer().serializeToString(featureRequest), conf)
      if (ret.data.features.length > 0)
      {
        this.flag = true
        let fidary = ret.data.features.map(item =>
        {
          return item.id.split('.')[1]
        })
        this.getDmkcary(fidary)
      }
      else
        this.$parent.loading = false
    },
    //清除空间分析图形
    clearGraphical()
    {
      this.measureAry.forEach(e =>
      {
        e.getSource().clear()
      })
      //关闭弹框
      this.flag = false
      //关闭绘制
      window.map.removeInteraction(draw)
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
    },
    //关闭插件
    closePul()
    {
      this.flag = false
    },
    //表头样式设置
    headercell(row, column, rowIndex, columnIndex)
    {
      return 'background: rgba(35, 134, 135, 0.7) !important;color: #23fffc;'
    },
    //修改表格行样式
    rowstyles({row, rowIndex})
    {
      if (rowIndex % 2 === 1)
      {
        let styleJson = {
          'background': 'rgba(2,36,38, .8) !important'
        }
        return styleJson
      }
      else
      {
        let styleJson = {
          'background': 'rgba(44,74,73, .8) !important'
        }
        return styleJson
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/SpaceAnalysis.vue